export enum AccountValidationStatus {
  CONFLICT = 'CONFLICT',
  OK = 'OK',
}

export interface AccountValidation {
  validationStatus: AccountValidationStatus
  correctEmailSuggestion?: string
}
